import { render, staticRenderFns } from "./WorkshopReview.vue?vue&type=template&id=f0c8adf2&scoped=true&"
import script from "./WorkshopReview.vue?vue&type=script&lang=js&"
export * from "./WorkshopReview.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopReview.vue?vue&type=style&index=0&id=f0c8adf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c8adf2",
  null
  
)

export default component.exports